import { markAllAsViewedAction } from "./../actions/activity/activityTypes"
import { Activity } from "@finway-group/shared/lib/models"
import { Reducer } from "react"

import { ActivityActions, ActivityActionTypes, FetchActivityAction, MarkAsViewedAction } from "../actions/activity/activityTypes"

export interface ActivityState {
    items: Activity[]
    totalUnseen: number
    totalPages: number
    totalDocs: number
}

const initialState = {
    items: [],
    totalUnseen: 0,
    totalPages: 0,
    totalDocs: 0,
}

const fetchActivity = (state: ActivityState, { activities, append, totalUnseen, totalDocs, totalPages }: FetchActivityAction): ActivityState => {
    return {
        ...state,
        items: append ? [...new Set(state.items.concat(activities))] : activities,
        totalUnseen,
        totalPages,
        totalDocs,
    }
}

const markActivityAsViewed = (state: ActivityState, action: MarkAsViewedAction): ActivityState => ({
    ...state,
    items: [...state.items.map((activity) => (activity.id === action.activity.id ? action.activity : activity))],
    totalUnseen: state.totalUnseen > 0 ? state.totalUnseen - 1 : 0,
})

const markAllActivitiesAsViewed = (state: ActivityState, { ids, userId }: markAllAsViewedAction): ActivityState => ({
    ...state,
    items: [
        ...state.items.map((activity) => {
            if (ids.indexOf(activity.id) > -1) {
                activity.viewedBy.push(userId)
                return activity
            }

            return activity
        }),
    ],
    totalUnseen: 0,
})

export const activityReducer: Reducer<ActivityState, ActivityActions> = (state = initialState, action) => {
    switch (action.type) {
        case ActivityActionTypes.FETCH_ACTIVITY:
            return fetchActivity(state, action)
        case ActivityActionTypes.MARK_AS_VIEWED:
            return markActivityAsViewed(state, action)
        case ActivityActionTypes.MARK_ALL_AS_VIEWED:
            return markAllActivitiesAsViewed(state, action)
        default:
            return state
    }
}
